import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EncryptService } from 'src/app/services/encrypt.service';
import { LoginService } from 'src/app/services/login.service';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  hide = true;
  logindata: any;

  loginForm: FormGroup;

  incorrectUser: boolean;


  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private encryptService: EncryptService,
  ) { }

  get f() { return this.loginForm.controls; }

  ngOnInit() {

    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });


  }

  // login(data) {
  //   this.ngxLoader.start();
  //   this.loginservice.dologin(data.value).subscribe((res) => {
  //     if (res.status.statusCode === 200) {
  //       localStorage.removeItem('logindata');
  //       localStorage.setItem('token', '123456');
  //       localStorage.setItem('logindata', JSON.stringify(res));  // save login response in local storage
  //       this.hoService.localStorageData = JSON.parse(localStorage.getItem('logindata'));
  //       this.loginservice.changeMessage(true);  
  //       this.router.navigate([res.navItems[0].routerLink]);       // page navigation
  //       this.ngxLoader.stop();                        // call data sharing service from login service
  //     }
  //     else {
  //       this.ngxLoader.stop();
  //       this.toastr.showError('Incorrect Username or Password');
  //     }
  //   })
  // }

  async onSubmitLoginForm() {

    if (this.loginForm.invalid) {
      return;
    }

    const payload = {
      userId: this.encryptService.encryptData(this.loginForm.controls.username.value),
      password: this.encryptService.encryptData(this.loginForm.controls.password.value)
    }

    const response = await this.loginService.login(payload);

   
    const active = response[0];
   
    // const active = '1';
    // console.log(active);

    // this.router.navigate(['/view-application']);

  if (active == '1') {
      localStorage.setItem("login",this.encryptService.encryptData("true"));
      this.incorrectUser = false;
      this.router.navigate(['/view-application']);
    }
    else{
      localStorage.setItem("login",this.encryptService.encryptData("false"));
      this.incorrectUser = true;
    }

  }
}
